import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { HERO_IMAGE } from "../../data/site";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 0.3 + i * 0.12 },
  }),
};

const Mask = ({ children, i }) => (
  <span className="block overflow-hidden">
    <motion.span custom={i} variants={line} initial="hidden" animate="show" className="block">
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 220]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const overlay = useTransform(scrollYProgress, [0, 1], [0.42, 0.7]);

  return (
    <section id="top" ref={ref} className="relative h-screen w-full overflow-hidden">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={HERO_IMAGE} alt="Homemade Indian pickles and spices" className="h-full w-full object-cover" />
        <motion.div style={{ opacity: overlay }} className="absolute inset-0 bg-black" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/20" />
      </motion.div>

      <div className="relative z-10 h-full mx-auto max-w-[1400px] px-5 md:px-10 flex flex-col justify-end pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#E28721] font-semibold mb-5"
        >
          Handmade in Ghaziabad · Small batch · Sun-cured
        </motion.p>

        <h1 className="font-serif text-white text-5xl sm:text-7xl md:text-[6.5rem] leading-[0.92] tracking-tight max-w-5xl">
          <Mask i={0}>Preserved with</Mask>
          <Mask i={1}>
            <span className="italic text-[#F0C27B]">patience</span>, packed
          </Mask>
          <Mask i={2}>with love.</Mask>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.8 }}
          className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 max-w-xl"
        >
          <p className="text-white/80 text-base md:text-lg leading-relaxed">
            Six honest jars of Indian achar — from fiery green chilli to sweet-sour turnip — made by hand from one woman's kitchen.
          </p>
          <a
            href="#pickles"
            data-testid="hero-cta"
            className="shrink-0 inline-flex items-center justify-center rounded-full bg-[#B83A14] hover:bg-[#942B0D] text-white px-7 py-3.5 text-sm tracking-wide transition-colors"
          >
            Taste the jars
          </a>
        </motion.div>
      </div>
    </section>
  );
};
